const PAYMENTS = {
  CASH: "cash",
  STRIPE: "stripe",
  PAYPAL: "paypal",
  POWERTRANZ: "powertranz"
}

export { PAYMENTS }
